import { render, staticRenderFns } from "./shared-carousel-slide.vue?vue&type=template&id=fa851b00"
import script from "./shared-carousel-slide.vue?vue&type=script&lang=js"
export * from "./shared-carousel-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports